import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tab, Tabs, Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const LinkTab = (props) => {
  return <Tab component={Link} color="primary" {...props} />;
};

const ProfileTabs = ({ tab, bookingActive, payoutDisabled }) => {
  return (
    <Box boxShadow={3}>
      <Tabs value={tab} indicatorColor="primary" textColor="primary" centered>
        <LinkTab
          label={<FormattedMessage id="userform.profile" defaultMessage="Profile" />}
          disabled={tab === 0}
          to={PATHS.users.profile}
        />
        {bookingActive && (
          <LinkTab
            label={<FormattedMessage id="products.Payout" defaultMessage="Payout" />}
            disabled={tab === 1 || payoutDisabled}
            to={PATHS.users.payout}
          />
        )}
      </Tabs>
    </Box>
  );
};

ProfileTabs.propTypes = {
  tab: PropTypes.number.isRequired,
  bookingActive: PropTypes.bool.isRequired,
  payoutDisabled: PropTypes.bool,
};

ProfileTabs.defaultProps = {
  payoutDisabled: false,
};

export default ProfileTabs;
